/**
 * Cooking system types — cooked food dishes, buffs, and messages.
 *
 * Round 13 Phase C: replaces HealthPotion/GreaterHealthPotion with a
 * server-authoritative food buff system. Buff descriptions use
 * feeling-based language per GDD.
 *
 * @packageDocumentation
 */
// ── Spoilage constants ───────────────────────────────────────────────
/**
 * Spoilage window in ms. Food spoils after ~3 in-world days.
 * In-world day = 20 real minutes, so 3 in-world days = 60 real minutes.
 */
export const FOOD_SPOILAGE_MS = 3 * 20 * 60 * 1000; // 3600000 ms = 60 min
// ── Messages ─────────────────────────────────────────────────────────
/** Client -> Server: request to cook a recipe at the home hearth. */
export const MSG_HOME_COOK = 'home_cook';
/** Server -> Client: cooking started, timer running. */
export const MSG_HOME_COOK_STARTED = 'home_cook_started';
/** Server -> Client: cooking completed, food item granted. */
export const MSG_HOME_COOK_COMPLETE = 'home_cook_complete';
/** Server -> Client: cooking request rejected. */
export const MSG_HOME_COOK_REJECTED = 'home_cook_rejected';
/** Server -> Client: food buff applied. */
export const MSG_FOOD_BUFF_APPLIED = 'food_buff_applied';
/** Server -> Client: food buff expired. */
export const MSG_FOOD_BUFF_EXPIRED = 'food_buff_expired';
/** Server -> Client: food item spoiled and removed from inventory. */
export const MSG_FOOD_SPOILED = 'food_spoiled';
/** Client -> Server: consume a food item from inventory at the home hearth. */
export const MSG_HOME_EAT_FOOD = 'home_eat_food';
/** Server -> Client: a recipe was discovered for the first time (SMA-76). */
export const MSG_RECIPE_DISCOVERED = 'recipe:discovered';
/** Server -> Client: Fool's 5th-craft triggered a discovery instead of the normal recipe. */
export const MSG_FOOL_DISCOVERY = 'fool_discovery';
/** Server -> Client: a Fool recipe has been added to the community recipe book. */
export const MSG_COMMUNITY_RECIPE_UNLOCKED = 'community_recipe_unlocked';
//# sourceMappingURL=cooking.js.map